import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useMatchedOpportunitiesOptions() {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('newest'),
        value: '-createdAt',
      },
      {
        label: t('oldest'),
        value: 'createdAt',
      },
      {
        label: t('highestMatchingRate'),
        value: '-matchPercentage',
      },
      {
        label: t('lowestMatchingRate'),
        value: 'matchPercentage',
      },
    ],
    [t],
  );
}
